'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _CoveApi = require('../lib/CoveApi');

var _CoveApi2 = _interopRequireDefault(_CoveApi);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class for the Payment Method API
 */
var PaymentMethod = function (_CoveAPI) {
  (0, _inherits3.default)(PaymentMethod, _CoveAPI);

  /**
   * Creates a new Item PaymentMethod Client
   * @param {string} host
   * @param {string} environment
   * @param {{accessToken: string, apiKey: string, refreshInterval: number}} auth
   */
  function PaymentMethod(host, environment, auth) {
    (0, _classCallCheck3.default)(this, PaymentMethod);
    return (0, _possibleConstructorReturn3.default)(this, (PaymentMethod.__proto__ || (0, _getPrototypeOf2.default)(PaymentMethod)).call(this, host, 'payment-method/v1', environment, auth));
  }

  /**
   * Sends a request to tigerlab to update the payment method
   * @param {string} customer_id
   * @param {*} item
   */


  (0, _createClass3.default)(PaymentMethod, [{
    key: 'update',
    value: function update(customer_id, paymentMethod, oldPaymentMethodId) {
      // Deep clone because the old payment method is part of an event which get recycled so we don't want to keep references to it
      var payment_method = JSON.parse((0, _stringify2.default)(paymentMethod));

      payment_method.customer = {
        customer_id: customer_id
      };

      payment_method.payment_method_id = oldPaymentMethodId;

      console.log('#- payment_method -#');
      console.log(payment_method);

      // Fix expiry date for credit cards. Tigerlab needs YYYY-MM-DD, we get MM/YY from bambora
      if (payment_method.credit_card) {
        var expiry = payment_method.credit_card.expiry_date;
        expiry = expiry.split('/');
        expiry = '20' + expiry[1] + '-' + expiry[0] + '-01';
        payment_method.credit_card.expiry_date = expiry;
      }
      return this.apiClient.fetch('POST', 'update', null, { payment_method: payment_method });
    }
  }, {
    key: 'updateStripe',
    value: function updateStripe(customer_id, paymentMethodId, oldPaymentMethodId) {
      var body = {
        customer_id: customer_id,
        payment_method_id: paymentMethodId,
        old_payment_method_id: oldPaymentMethodId
      };
      return this.apiClient.fetch('POST', 'update-stripe', null, body);
    }
  }, {
    key: 'status',
    value: function status(customer_id) {
      return this.apiClient.fetch('GET', 'status', { customer_id: customer_id });
    }
  }]);
  return PaymentMethod;
}(_CoveApi2.default);

exports.default = PaymentMethod;